import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private sideNavVisible = new BehaviorSubject<boolean>(true);
  sideNavVisible$ = this.sideNavVisible.asObservable();

  toggleSideNav() {
    const currentVisibility = this.sideNavVisible.getValue();
    this.sideNavVisible.next(!currentVisibility);
  }

  closeSideNav() {
    this.sideNavVisible.next(false);
  }

  openSideNav() {
    this.sideNavVisible.next(true);
  }
}
